export default "__VITE_ASSET__9b2d300a__"